/* Moosy · secondo pulitore nel carrello laterale.
   Compare solo se nel carrello c'è almeno un kit. Al massimo 1 secondo pulitore per ogni kit:
   se il cliente toglie il kit, il secondo pulitore viene ridotto di conseguenza. */
(function(){
  const box=document.querySelector('[data-cd2]'); if(!box||!window.Moosy) return;
  const C=JSON.parse(document.querySelector('[data-cd2-json]').textContent);
  const R=(window.MoosySettings&&window.MoosySettings.routes)||{cart:'/cart',cartAdd:'/cart/add',cartChange:'/cart/change'};
  const kitIds=(C.kits||[]).map(Number), second=+C.variant;
  let busy=false, fixing=false;
  const H={'Content-Type':'application/json',Accept:'application/json'};
  async function cartJs(){ const r=await fetch(R.cart+'.js',{headers:{Accept:'application/json'}}); return r.json(); }
  async function check(){
    if(!second) return;
    let c; try{ c=await cartJs(); }catch(e){ return; }
    const kits=c.items.filter(i=>kitIds.includes(i.variant_id)).reduce((a,i)=>a+i.quantity,0);
    const line=c.items.find(i=>i.variant_id===second), have=line?line.quantity:0;
    if(have>kits){
      if(fixing) return; fixing=true;
      try{ await fetch(R.cartChange+'.js',{method:'POST',headers:H,body:JSON.stringify({id:line.key,quantity:kits})});
        document.dispatchEvent(new CustomEvent('moosy:cart:added',{detail:{fix:true}})); }
      finally{ fixing=false; }
      return;
    }
    box.hidden=!(kits>0&&have<kits);
  }
  box.querySelector('[data-cd2-add]').addEventListener('click',async e=>{
    if(busy) return; busy=true; const b=e.currentTarget; b.setAttribute('aria-busy','true');
    try{ await fetch(R.cartAdd+'.js',{method:'POST',headers:H,body:JSON.stringify({items:[{id:second,quantity:1}]})});
      window.Moosy.track('upsell_add',{upsell:'second_cleaner',value:(C.price||0)/100});
      document.dispatchEvent(new CustomEvent('moosy:cart:added',{detail:{second:true}})); }
    finally{ busy=false; b.removeAttribute('aria-busy'); }
  });
  const lines=document.querySelector('[data-cd-lines]');
  if(lines) new MutationObserver(()=>check()).observe(lines,{childList:true});
  document.addEventListener('moosy:cart:added',()=>setTimeout(check,400));
  check();
})();

/* 2 ott · Pagamento rapido nel carrello: una riga con Apple Pay / Google Pay / Shop Pay sotto "Vai al pagamento".
   I pulsanti li disegna Shopify (sezione moosy-wallets) e vengono ricaricati a ogni cambio del totale,
   così il foglio Apple Pay / Google Pay mostra sempre l'importo giusto.
   Nota: la richiesta va fatta SENZA header Accept: application/json, altrimenti Shopify restituisce la sezione vuota. */
(function(){
  const go=document.querySelector('[data-cd-go]'); if(!go) return;
  const base=(window.Shopify&&Shopify.routes&&Shopify.routes.root)||'/';
  const st=document.createElement('style');
  st.textContent='.m-cd__or{display:flex;align-items:center;gap:10px;margin:12px 0 8px;font-size:12px;line-height:1;color:#6b6b6b}.m-cd__or::before,.m-cd__or::after{content:"";flex:1;height:1px;background:#EADFCF}.m-cd__or[hidden],.m-cd__wallets[hidden]{display:none}.m-cd__wallets{--shopify-accelerated-checkout-button-block-size:48px;--shopify-accelerated-checkout-button-inline-size:48px;--shopify-accelerated-checkout-button-border-radius:999px;--shopify-accelerated-checkout-row-gap:8px;--shopify-accelerated-checkout-inline-alignment:center;margin-bottom:6px}';
  document.head.appendChild(st);
  const or=document.createElement('p'); or.className='m-cd__or'; or.hidden=true; or.innerHTML='<span>oppure paga in un tocco</span>';
  const box=document.createElement('div'); box.className='m-cd__wallets'; box.hidden=true;
  go.after(or,box);
  let n=0, t=null;
  async function load(){
    const my=++n;
    try{
      const r=await fetch(base+'?sections=moosy-wallets'); const j=await r.json(); if(my!==n) return;
      const tmp=document.createElement('div'); tmp.innerHTML=j['moosy-wallets']||'';
      const s=tmp.querySelector('.shopify-section'); const h=(s?s.innerHTML:tmp.innerHTML).trim();
      box.innerHTML=h; box.hidden=or.hidden=!h;
    }catch(e){}
  }
  const later=()=>{ clearTimeout(t); t=setTimeout(load,300); };
  const p=document.querySelector('[data-cd-go-p]');
  if(p) new MutationObserver(later).observe(p,{childList:true,characterData:true,subtree:true});
  load();
})();

/* 2 ott · Pagina prodotto.
   1) Pagamento rapido (Apple Pay / Google Pay sotto "Aggiungi al carrello"): il pulsante di Shopify legge il PRIMO campo "id"
      del form, che con i kit a scelta era sempre il Solo da 39,90. Mettiamo in testa al form un select nascosto "id"
      sempre allineato al kit scelto, così paga il kit giusto.
   2) All'apertura della pagina i tasti carrello più in basso (es. "Sembravano pulite") restavano senza nome kit e prezzo
      finché il cliente non cambiava kit: qui ripetiamo l'annuncio del kit preselezionato quando tutti gli script sono pronti. */
(function(){
  function init(){
    const f=document.querySelector('form[data-offer]'); if(!f||f.querySelector('select.m-bb__vid')) return;
    const radios=[...f.querySelectorAll('input[type="radio"][name="id"]')]; if(!radios.length) return;
    const s=document.createElement('select'); s.name='id'; s.className='m-bb__vid'; s.hidden=true; s.tabIndex=-1; s.setAttribute('aria-hidden','true');
    radios.forEach(r=>{ const o=document.createElement('option'); o.value=r.value; o.textContent=r.value; s.appendChild(o); });
    f.prepend(s);
    const sync=()=>{ const r=radios.find(x=>x.checked); if(r&&s.value!==r.value){ s.value=r.value; s.dispatchEvent(new Event('change',{bubbles:true})); } };
    f.addEventListener('change',e=>{ if(e.target!==s) sync(); });
    const dyn=f.querySelector('.m-bb__dyn');
    if(dyn) ['pointerdown','touchstart','mousedown','keydown','click'].forEach(ev=>dyn.addEventListener(ev,sync,{capture:true,passive:true}));
    new MutationObserver(sync).observe(f,{subtree:true,attributes:true,attributeFilter:['class']});
    sync();
    try{
      const sec=f.closest('section')||document; const pj=sec.querySelector('[data-product-json]'); if(!pj) return;
      const P=JSON.parse(pj.textContent), r=radios.find(x=>x.checked); if(!r) return;
      const v=(P.variants||[]).find(x=>String(x.id)===String(r.value)); if(!v) return;
      document.dispatchEvent(new CustomEvent('moosy:variant',{detail:{variant:v,title:r.dataset.title,gifts:(P.variant_gifts||{})[v.id]||[],shipping:(P.shipping||{}).flat}}));
    }catch(e){}
  }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',init); else init();
})();
